import { render, staticRenderFns } from "./OrgList.vue?vue&type=template&id=6debe0ed&scoped=true"
import script from "./OrgList.vue?vue&type=script&lang=js"
export * from "./OrgList.vue?vue&type=script&lang=js"
import style0 from "./OrgList.vue?vue&type=style&index=0&id=6debe0ed&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6debe0ed",
  null
  
)

export default component.exports